import type { AnalyticsEventName, AnalyticsEventProperties, AnalyticsProvider } from './contracts';

type YandexFunction = (...args: unknown[]) => void;
type GoogleFunction = (...args: unknown[]) => void;

export function createYandexProvider(counterId: number, send: YandexFunction): AnalyticsProvider {
  return {
    pageView: (path) => send(counterId, 'hit', path),
    event: (name, properties) => send(counterId, 'reachGoal', name, properties),
  };
}

export function createGoogleProvider(send: GoogleFunction): AnalyticsProvider {
  return {
    pageView: (path) => send('event', 'page_view', { page_path: path }),
    event: <Name extends AnalyticsEventName>(
      name: Name,
      properties: AnalyticsEventProperties[Name]
    ) => send('event', name, properties),
  };
}
